/* Command bar above a table (DESIGN_SYSTEM §4, §6). */
.bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2) var(--space-4);
  min-block-size: 3.25rem;
  padding: var(--space-2) var(--space-3);
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-surface);
}

.start {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  padding-inline-end: var(--space-4);
  border-inline-end: var(--border-width) solid var(--color-rule);
}

.selection {
  display: flex;
  flex: 1 1 18rem;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  min-inline-size: 0;
  color: var(--color-text-muted);
  font-size: var(--text-sm);
}

.end {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  margin-inline-start: auto;
  color: var(--color-text-muted);
  font-size: var(--text-xs);
}

/* What the selection zone holds: the selected row's name, then its tools (or the prompt). */
.selectionTools {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
}

/* Desktop: two rows of constant height, so the table never moves when a row is selected or when
   the selection moves between states with more or fewer tools (RI-07): the start zone with the
   selected row's name, then the tools, or the prompt, on a row of their own across the bar. */
@media (min-width: 64.0625rem) {
  .bar {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr) auto;
    grid-template-areas:
      'start label end'
      'tools tools tools';
    align-items: center;
  }

  .start {
    grid-area: start;
  }

  .end {
    grid-area: end;
  }

  .selection {
    display: contents;
  }

  .selectionLabel {
    grid-area: label;
    min-inline-size: 0;
  }

  .selectionTools {
    grid-area: tools;
    min-block-size: 2.25rem;
  }
}

/* Phones: while a row is selected, its tools dock at the bottom of the viewport (one bottom layer). */
@media (max-width: 40rem) {
  .bar {
    padding: var(--space-2);
  }

  .start {
    flex: 1 1 100%;
    padding-inline-end: 0;
    border-inline-end: 0;
  }

  .start > * {
    flex: 1 1 0;
  }

  /* Never an overflow menu (RD4-01): every tool stays a labelled 44 px button and the zone wraps. */
  .docked {
    position: fixed;
    inset-inline: 0;
    inset-block-end: 0;
    z-index: 40;
    max-block-size: 60dvh;
    overflow-y: auto;
    padding: var(--space-2) var(--space-3) calc(var(--space-2) + env(safe-area-inset-bottom, 0));
    border-block-start: var(--border-width) solid var(--color-border);
    background: var(--color-surface);
    box-shadow: 0 -6px 20px rgb(7 46 42 / 0.12);
  }

  .docked button,
  .docked a {
    flex: 1 1 auto;
    min-block-size: 2.75rem;
  }
}
